import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { StudentPendingActionsVM } from "@shared-kernel/application/ports/student/student-repository";

export const studentRetrievePendingActions = createAsyncThunk<StudentPendingActionsVM, void, { extra: Partial<Dependencies> }>(
  "student/studentRetrievePendingActions",
  async (_: void, { extra: { studentRepository } }) => {
    return studentRepository!.hasPendingActions();
  },
);
